const VOLTAGE_120 = 'VOLTAGE_120'
const VOLTAGE_220 = 'VOLTAGE_220'

const objects = {
    [VOLTAGE_120]: {
        type: '120v',
        label: '120 Volts',
    },
    [VOLTAGE_220]: {
        type: '220v',
        label: '220 Volts',
    },
}

export default Object.freeze(objects)
export const ordered = Object.freeze([objects.VOLTAGE_120, objects.VOLTAGE_220])

export const byValue = (value) => {
    return Object.values(objects).find(({ type }) => value === type)
}
